<script setup>
import {ref, watch} from 'vue'
import {codePreview, formatDate, setButtonContentDefault, setButtonContentLoading} from '@/helper';
import {Dialog, DialogPanel, DialogTitle, TransitionChild, TransitionRoot} from '@headlessui/vue'
import documentService from '@/services/DocumentService';
import {authData, generate2faCode} from '@/services/AuthService';
import Checkbox from '@/components/forms/Checkbox.vue';
import Input from '@/components/forms/Input.vue';
import Select from '@/components/forms/Select.vue';
import {useI18n} from 'vue-i18n';

const {t} = useI18n()
const props = defineProps({
  intermediariesPeople: {type: Array, required: true},
});
const emit = defineEmits(['confirm', 'cancel']);

const errorMessage = ref('');
const isOpen = ref(true)
const form = ref({
  owner: false,
  responsible: false,
  responsible_id: null
})

const closeModalWith = (value) => {
  isOpen.value = false;
  setTimeout(() => {
    if (value === 'confirm') {
      emit('confirm', form.value);
    } else {
      emit('cancel');
    }
  }, 300);
}

function openModal() {
  isOpen.value = true
}

</script>

<template>
  <TransitionRoot appear :show="isOpen" as="template">
    <Dialog as="div"  class="modal show d-block" style="z-index: 1055;">
      <div class="modal-backdrop fade show"></div>
      <div class="modal-dialog modal-dialog-centered modal-lg" style="z-index: 1055">
        <div class="modal-content">
          <DialogPanel class="modal-body p-4 rounded-lg shadow-lg">
            <div class="modal-header">
              <DialogTitle as="h3" class="modal-title">
                {{ t('signSettingsModal.signature_settings') }}
              </DialogTitle>
              <i class="btn-close cursor-pointer" @click="closeModalWith('cancel')" aria-label="Close"></i>
            </div>
              <div class="modal-body">
                <div class="row">
                  <div class="col-12 form-group">
                    <div class="form-check mt-3 mb-3">
                      <label for="ownerCheckbox" class="form-check-label">{{ t('signSettingsModal.require_signature_owner') }}</label>
                      <input v-model="form.owner" id="ownerCheckbox" type="checkbox" class="form-check-input"/>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-12 form-group">
                    <div class="form-check mt-3 mb-3">
                      <label for="responsibleCheckbox" class="form-check-label">{{ t('signSettingsModal.require_signature_responsible_person') }}</label>
                      <input v-model="form.responsible" id="responsibleCheckbox" type="checkbox" class="form-check-input"/>
                    </div>
                  </div>
                </div>
                <div class="row" v-if="form.responsible">
                  <div class="col-12 form-group mb-3">
                    <label for=""  class="form-label">{{ t('signSettingsModal.responsible_person') }}</label>
                    <select v-model="form.responsible_id" class="w-100 form-select form-control">
                      <option v-for="(intermediaryPeople) in intermediariesPeople" :key="intermediaryPeople" :value="intermediaryPeople.user?.id" :disabled="!intermediaryPeople.user">
                        {{ intermediaryPeople.label }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="alert alert-danger mt-3" v-if="errorMessage"> {{errorMessage}} </div>
              </div>
            <div class="modal-footer">
              <button class="btn btn-link text-decoration-underline text-dark" type="button" @click="closeModalWith('cancel')">{{ t('signSettingsModal.cancel') }}</button>
              <button class="btn btn-primary btn-md" type="button" @click="closeModalWith('confirm')">{{ t('signSettingsModal.save') }}</button>
            </div>
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
</template>

